<script>
export default {
  methods: {
    verifyMode(mode) {
      if (!['numeric', 'alphanumeric'].includes(mode)) {
        throw new Error(`Unknown mode: ${mode}`)
      }
    },
    getInputMode(mode) {
      if (mode === 'alphanumeric') {
        return 'text'
      } else {
        return 'numeric'
      }
    },
    onlyNumbers(value) {
      return value.replace(/\D+/gi, '')
    },
    sanitizeText(text, mode) {
      if (mode === 'numeric') {
        return this.onlyNumbers(text || '')
      } else if (mode === 'alphanumeric') {
        return (text || '').toUpperCase().trim()
      }
    }
  }
}
</script>
